import { Routes } from '@/api/Routes';
import { http } from '@/common/utils/HttpServices';

export interface FilterDevis {
    id?: number;
    page?: number;
    chantierIds?: number[];
    numDevis?: string;
    numCommande?: string;
    numFacture?: string;
    etatDevis?: string[];
    dateDebut?: string;
    dateFin?: string;
    sort?: string;
    isBim?: boolean;
    phasesIds: number[];
}

class OrigineDemande {
    readonly origineDemande: string = 'PORTAIL';
}

export class CommanderDevis extends OrigineDemande {
    chiffrageId: number;
    numeroCommande?: string;

    constructor(chiffrageId: number, numeroCommande: string) {
        super();
        this.chiffrageId = chiffrageId;
        this.numeroCommande = numeroCommande;
    }
}

export class DevisAsigner extends OrigineDemande {
    chiffrageId: number;
    email: string;
    nom: string;
    prenom: string;

    constructor(chiffrageId: number, email: string, nom: string, prenom: string) {
        super();
        this.chiffrageId = chiffrageId;
        this.email = email;
        this.nom = nom;
        this.prenom = prenom;
    }
}

export interface DevisSignerDTO {
    chiffrageId: number;
    nom?: string;
    prenom?: string;
    email?: string;
    fonction?: string;
    returnUrl: string;
}

export interface SignatureDevisResponseDTO {
    url: string;
}

export class RefusDevis extends OrigineDemande {
    chiffrageId: number;
    raison: string;
    commentaire: string | null;

    constructor(chiffrageId: number, raison: string, commentaire: string) {
        super();
        this.chiffrageId = chiffrageId;
        this.raison = raison;
        this.commentaire = commentaire;
    }
}

class DevisService {
    public async getListDevis(params: FilterDevis): Promise<any> {
        return http.get(Routes.EstimateRoutes.GetListDevis(), { params });
    }
    public async getDevis(id: number): Promise<any> {
        return http.get(Routes.EstimateRoutes.GetDevis(id));
    }
    public async getDevisPDF(numero: number, version: number): Promise<any> {
        return http.get<Blob>(Routes.EstimateRoutes.GetDevisPDF(numero, version), { responseType: 'blob' });
    }
    public async postRefuseEstimate(params: RefusDevis): Promise<any> {
        return http.post(Routes.EstimateRoutes.PostRefuseEstimate(), params);
    }
    public async postCommanderEstimate(params: CommanderDevis, bonDeCommande: File): Promise<any> {
        const formData = await this.getFormDataBonCommande(params, 'devisACommander', bonDeCommande);
        return await http.post(Routes.EstimateRoutes.PostCommanderEstimate(), formData);
    }

    public async postSignerDevis(params: DevisSignerDTO): Promise<{ data: SignatureDevisResponseDTO }> {
        return http.post(Routes.EstimateRoutes.PostSignEstimate(), params);
    }

    public async deleteSignature(chiffrageId: number): Promise<any> {
        return http.delete(Routes.EstimateRoutes.DeleteSignature(chiffrageId));
    }

    public async getExportXlsDevis(params: FilterDevis): Promise<any> {
        return http.get(Routes.EstimateRoutes.GetExportXlsDevis(), { params, responseType: 'arraybuffer' });
    }

    private async getFormDataBonCommande(dto: any, formDataKey: string, bonDeCommande: File): Promise<FormData> {
        const formData = new FormData();
        const transformToBlobJson = (data: any) => new Blob([JSON.stringify(data)], { type: 'application/json' });
        formData.append(formDataKey, transformToBlobJson(dto));
        if (bonDeCommande) {
            const blob = await this.fileToBlob(bonDeCommande);
            formData.append('bonDeCommande', blob, bonDeCommande.name);
        }
        return formData;
    }

    private async fileToBlob(file: File): Promise<Blob> {
        return new Promise(resolve => {
            const reader = new FileReader();
            reader.onloadend = () => reader.readAsBinaryString(file);
            resolve(file);
        });
    }
}

export default new DevisService();
